module.exports = __webpack_public_path__ + "img/shir_no.053ca6e1.png";